import { Router as WouterRouter } from "wouter";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { useScrollToTop } from "./hooks/useScrollToTop";
import { ToastContainer } from "react-toastify";
import { WhatsAppButton } from "./components/common/WhatsAppButton";
import AppRoutes from "./routes/AppRoutes";

function ScrollToTop() {
  useScrollToTop();
  return null;
}

function App() {
  return (
    <WouterRouter>
      <ScrollToTop />
      <ToastContainer />
      <Navbar />
      <main>
        <AppRoutes />
      </main>
      <Footer />
      <WhatsAppButton />
    </WouterRouter>
  );
}

export default App;